<template>
  <el-card shadow="never" class="aui-card--fill">
    <div class="mod-student__student">
      <el-form :inline="true" :model="dataForm" @keyup.enter.native="getDataList()">
        <el-form-item>
          <el-input v-model="dataForm.studentName" placeholder="学生姓名" clearable></el-input>
        </el-form-item>
        <el-form-item>
          <el-input v-model="dataForm.className" placeholder="班级名" clearable></el-input>
        </el-form-item>
        <el-form-item>
          <el-input v-model="dataForm.idCardNum" placeholder="身份证号" clearable></el-input>
        </el-form-item>
        <el-form-item prop="schoolId" v-if="$hasPermission('admin:admin:student')">
          <el-select v-model="dataForm.schoolId" placeholder="请选择学校" clearable>
            <el-option
                    v-for="school in schoolList"
                    :value="school.id"
                    :label="school.schoolName"
                    :key="school.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button @click="getDataList()">{{ $t('query') }}</el-button>
        </el-form-item>
        <el-form-item>
          <el-button v-if="$hasPermission('student:student:save')" type="primary" @click="addOrUpdateHandle()">
            {{ $t('add') }}
          </el-button>
        </el-form-item>
        <el-form-item>
          <el-button v-if="$hasPermission('student:student:delete')" type="danger" @click="deleteHandle()">
            {{ $t('deleteBatch') }}
          </el-button>
        </el-form-item>
        <el-form-item>
          <el-button v-if="$hasPermission('student:role:config')" type="primary" @click="studentRoleConfigHandle()">
            学生角色关联
          </el-button>
        </el-form-item>
        <el-form-item>
          <el-button v-if="$hasPermission('student:dept:config')" type="primary" @click="studentDeptConfigHandle()">
            学生部门关联
          </el-button>
        </el-form-item>
        <el-from-item>
          <el-button v-if="$hasPermission('student:student:import')" type="primary" @click="studentImportHandle()">
            学生导入
          </el-button>
        </el-from-item>
        <el-from-item><!---->
          <el-button v-if="$hasPermission('student:student:studentInfo')" style="margin-left: 10px" type="primary" @click="studentImgHandle()">
            学籍信息录入通道
          </el-button>
        </el-from-item>
        <el-form-item>
          <el-button  type="primary" style="margin-left: 10px"
                      v-if="$hasPermission('student:student:studentInfoExport')"
                      @click="exportStudentStatusInfoList()">导出学生学籍
          </el-button>
        </el-form-item>
        <!--<el-from-item>
          <el-button  type="primary" @click="download()">
            学生学籍二维码下载
          </el-button>
        </el-from-item>-->
        <el-form-item>
          <el-button v-if="$hasPermission('teacher:teacher:viewWeChatBand')" type="primary" @click="viewWeChatBand()">
            微信绑定情况
          </el-button>
        </el-form-item>
        <el-form-item>
          <el-button v-if="$hasPermission('student:student:save')" type="primary" @click="transferClassTeacherMessageHandle()">学生转班班主任通知
          </el-button>
        </el-form-item>
        <el-form-item>
          <el-button v-if="$hasPermission('student:student:save')" type="primary" @click="transferClassAgreeMessageHandle()">学生转班同意通知
          </el-button>
        </el-form-item>
		 <el-form-item>
          <el-button v-if="$hasPermission('student:student:save')" type="primary" @click="studentUpdateHandle()">学生信息更新
          </el-button>
        </el-form-item>
        <el-from-item>
          <el-button v-if="$hasPermission('student:student:import')" type="primary" @click="studentYoungPioneersImportHandle()">
            学生少先队信息导入
          </el-button>
        </el-from-item>
      </el-form>
      <el-table v-loading="dataListLoading" :data="dataList" border @selection-change="dataListSelectionChangeHandle"
                style="width: 100%;">
        <el-table-column type="selection" header-align="center" align="center" width="50"></el-table-column>
        <el-table-column prop="studentName" label="学生姓名" header-align="center" align="center"></el-table-column>
        <el-table-column prop="setNum" label="座号" header-align="center" align="center"></el-table-column>
        <el-table-column prop="studentNum" label="学号" header-align="center"
                         align="center"></el-table-column>
        <el-table-column prop="className" label="班级" header-align="center" align="center"></el-table-column>
        <el-table-column prop="idCardNum" label="身份证号" header-align="center" align="center"></el-table-column>
<!--        <el-table-column prop="studentSex" label="性别" header-align="center" align="center">-->
<!--          <template slot-scope="scope">-->
<!--            {{ $getDictLabel("gender", scope.row.studentSex) }}-->
<!--          </template>-->
<!--        </el-table-column>-->
        <el-table-column prop="schoolYearName" label="学年" header-align="center" align="center"></el-table-column>
        <el-table-column prop="schoolName" label="学校" header-align="center" align="center"></el-table-column>
        <el-table-column header-align="center" align="center" prop="studentState" label="学生状态">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.studentState===studentSate.normal" type="success">正常</el-tag>
            <el-tag v-if="scope.row.studentState===studentSate.suspension" type="warning">休学</el-tag>
            <el-tag v-if="scope.row.studentState===studentSate.transfer" type="danger">转学</el-tag>
            <el-tag v-if="scope.row.studentState===studentSate.activeChangeClass" type="warning">主动转班</el-tag>
            <el-tag v-if="scope.row.studentState===studentSate.passiveChangeClass" type="info">被动转班</el-tag>
            <el-tag v-if="scope.row.studentState===studentSate.noTest" type="warning">寄读</el-tag>
            <el-tag v-if="scope.row.studentState===studentSate.filed" type="warning">归档</el-tag>
          </template>
        </el-table-column>
        <el-table-column :label="$t('handle')" fixed="right" header-align="center" align="center" width="150">
          <template slot-scope="scope">
            <el-button v-if="$hasPermission('student:student:update')" type="text" size="small"
                       @click="addOrUpdateHandle(scope.row.id)">{{ $t('update') }}
            </el-button>
            <el-button v-if="$hasPermission('student:student:delete')" type="text" size="small"
                       @click="deleteHandle(scope.row.id)">{{ $t('delete') }}
            </el-button><!---->
            <el-button v-if="$hasPermission('student:statusInfo')" type="text" size="small"
                       @click="showStudentStatsInfo(scope.row)">学籍信息
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
          :current-page="page"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="limit"
          :total="total"
          layout="total, sizes, prev, pager, next, jumper"
          @size-change="pageSizeChangeHandle"
          @current-change="pageCurrentChangeHandle">
      </el-pagination>
      <!-- 弹窗, 新增 / 修改 -->
      <add-or-update v-if="addOrUpdateVisible" ref="addOrUpdate" @refreshDataList="getDataList"></add-or-update>
      <!--   学生角色配置   -->
      <student-role-config v-if="studentRoleConfigVisible" ref="studentRoleConfig"></student-role-config>
      <!--  学生部门配置   -->
      <student-dept-config v-if="studentDeptConfigVisible" ref="studentDeptConfig"></student-dept-config>
      <!--   学生导入   -->
      <student-import v-if="studentImportVisible" ref="studentImport" @refreshDataList="getDataList"></student-import>

	  <student-update-import v-if="studentUpdateImportVisible" ref="studentUpdateImport" @refreshDataList="getDataList"></student-update-import>

      <!--学籍信息-->
      <student-status-info v-if="studentStatusInfoVisible"></student-status-info>
      <!--学籍二维码-->
      <student-info-img v-if="studentInfoImgVisible" ref="studentInfoImg"></student-info-img>
      <!--选择班级-->
      <class-select v-if="classVisible" ref="classSelect"></class-select>
      <!--查看学生家长微信绑定情况-->
      <view-student-we-chat-band v-if="viewWeChatBandVisible" ref="viewWeChatBand" @refreshDataList="getDataList"></view-student-we-chat-band>
      <!--学生转班班主任通知 -->
      <transfer-class-teacher-message v-if="transferClassTeacherMessageVisible" ref="transferClassTeacherMessage" @refreshDataList="getDataList"></transfer-class-teacher-message>
      <!--学生转班同意通知 -->
      <transfer-class-agree-message v-if="transferClassAgreeMessageVisible" ref="transferClassAgreeMessage" @refreshDataList="getDataList"></transfer-class-agree-message>
      <!--   学生少先队信息导入   -->
      <student-young-pioneers-import v-if="studentYoungPioneersImportVisible" ref="studentYoungPioneersImport" @refreshDataList="getDataList"></student-young-pioneers-import>
    </div>
   <!-- <div id="1" style="display: none">
      <vue-qr :correctLevel="3"
              :logoScale="0.3"
              :text="qrCodeText"
              :size="256"
              :margin="10"
              :dotScale="1"
              colorDark="#2c5ea8"
              style="margin: 10px">
      </vue-qr>
    </div>
    <canvas id="box" style="display: none;background: #FFFFFF;" width="270px"
            height="300px"></canvas>-->
  </el-card>
</template>

<script>
import mixinViewModule from '@/mixins/view-module'
import AddOrUpdate from './student-add-or-update'
import StudentRoleConfig from './student-role-config'
import StudentDeptConfig from './student-dept-config'
import StudentImport from './student-import'
import StudentUpdateImport from './student-update-import'
import { studentSate } from '@/constant'
import studentStatusInfo from './student-status-info'
import StudentInfoImg from './student-info-img'
import { moduleRoutes } from '@/router'
import ClassSelect from './class-select'
import ViewStudentWeChatBand from './view-student-wechat-band'
import TransferClassTeacherMessage from './transfer_class_teacher_message'
import TransferClassAgreeMessage from './transfer_class_agree_message'
import VueQr from 'vue-qr'
import StudentYoungPioneersImport from './student-young-pioneers-import'
export default {
  mixins: [mixinViewModule],
  data () {
    return {
      mixinViewModuleOptions: {
        getDataListURL: '/student/student/page',
        getDataListIsPage: true,
        deleteURL: '/student/student',
        deleteIsBatch: true
      },
      studentSate,
      transferClassTeacherMessageVisible: false,
      transferClassAgreeMessageVisible: false,
      viewWeChatBandVisible: false,
      studentRoleConfigVisible: false,
      studentDeptConfigVisible: false,
      studentImportVisible: false,
      studentYoungPioneersImportVisible: false,
	  studentUpdateImportVisible: false,
      studentStatusInfoVisible: false,
      studentInfoImgVisible: false,
      classVisible: false,
      schoolList: [],
      qrCodeText: '',
      dataForm: {
        studentName: '',
        className: '',
        idCardNum: '',
        schoolId: ''
      }
    }
  },
  methods: {
    studentRoleConfigHandle () {
      this.studentRoleConfigVisible = true
      this.$nextTick(() => {
        this.$refs.studentRoleConfig.init()
      })
    },
    studentDeptConfigHandle () {
      this.studentDeptConfigVisible = true
      this.$nextTick(() => [
        this.$refs.studentDeptConfig.init()
      ])
    },
    studentImportHandle () {
      this.studentImportVisible = true
      this.$nextTick(() => {
        this.$refs.studentImport.init()
      })
    },
    studentUpdateHandle () {
      this.studentUpdateImportVisible = true
      this.$nextTick(() => {
        this.$refs.studentUpdateImport.init()
      })
    },
    studentImgHandle () {
      this.studentInfoImgVisible = true
      this.$nextTick(() => {
        this.$refs.studentInfoImg.init()
      })
    },
    showStudentStatsInfo (row) {
      const routeName = `${this.$route.name}_${row.id}`
      let route = window.SITE_CONFIG.dynamicRoutes.filter(item => item.name === routeName)[0]
      if (route) {
        return this.$router.push({ name: routeName, params: { id: row.id, studentName: row.studentName, studentNum: row.studentNum, idCardNum: row.idCardNum, studentSex: row.studentSex } })
      }
      route = {
        path: routeName,
        component: () => import('@/views/modules/student/student-status-info.vue'),
        name: routeName,
        meta: {
          ...window.SITE_CONFIG.contentTabDefault,
          menuId: this.$route.meta.menuId,
          title: '学生学籍信息'
        }
      }
      this.$router.addRoutes([{
        ...moduleRoutes,
        name: `main-dynamic__${route.name}`,
        children: [route]
      }])
      window.SITE_CONFIG.dynamicRoutes.push(route)
      this.$router.push({ name: route.name, params: { id: row.id, studentName: row.studentName, studentNum: row.studentNum, idCardNum: row.idCardNum, studentSex: row.studentSex } })
    },
    getSchoolList () {
      this.$http.get('school/school/getSchoolList').then(({ data: res }) => {
        if (res.code !== 0) {
          return this.$message.error(res.msg)
        }
        this.schoolList = res.data
        console.log(this.schoolList)
      })
    },
    exportStudentStatusInfoList () {
      this.classVisible = true
      this.$nextTick(() => {
        this.$refs.classSelect.init()
      })
    },
    transferClassTeacherMessageHandle () {
      this.transferClassTeacherMessageVisible = true
      this.$nextTick(() => {
        this.$refs.transferClassTeacherMessage.init()
      })
    },
    transferClassAgreeMessageHandle () {
      this.transferClassAgreeMessageVisible = true
      this.$nextTick(() => {
        this.$refs.transferClassAgreeMessage.init()
      })
    },
    viewWeChatBand () {
      this.viewWeChatBandVisible = true
      this.$nextTick(() => {
        this.$refs.viewWeChatBand.init()
      })
    },
    studentYoungPioneersImportHandle () {
      this.studentYoungPioneersImportVisible = true
      this.$nextTick(() => {
        this.$refs.studentYoungPioneersImport.init()
      })
    }
  },
  mounted () {
    this.getSchoolList()
  },
  watch: {},
  components: {
    AddOrUpdate,
    StudentRoleConfig,
    StudentDeptConfig,
    StudentImport,
    StudentUpdateImport,
    studentStatusInfo,
    StudentInfoImg,
    ViewStudentWeChatBand,
    TransferClassTeacherMessage,
    TransferClassAgreeMessage,
    // eslint-disable-next-line vue/no-unused-components
    VueQr,
    StudentYoungPioneersImport,
    ClassSelect
  }
}
</script>
